import React from 'react'

import styles from './Container.module.scss'

export default (props: {children?: React.ReactNode, className?: string}) => {
  return (<div className={`${styles.container} ${props.className||''}`}>{props.children}</div>)
}
